<template>
  <div>
    <v-text-field
      :value="value.headline"
      label="Headline"
      outlined
      dense
      @input="update('headline', $event)"
    />
    <v-textarea
      :value="value.subtext"
      label="Subtext"
      outlined
      dense
      rows="2"
      @input="update('subtext', $event)"
    />
    <v-text-field
      :value="value.ctaText"
      label="Button Text"
      outlined
      dense
      @input="update('ctaText', $event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, default: () => ({}) },
  },
  methods: {
    update(key, val) {
      this.$emit("input", { ...this.value, [key]: val });
    },
  },
};
</script>
